import React, { Component } from 'react';
import _ from 'lodash';
import Papa from 'papaparse';
import config from '../config';
import {
    Link,
    Redirect
} from "react-router-dom";
import { AuthContext } from "../context/auth";
import fetcher from "../context/fetcher";
import { downloadFile, readFileAsync } from "../components/ImportExport";

export default class Products extends Component {
    static contextType = AuthContext;

    constructor(props, context) {
        super(props);
        this.authContext = context;
        this.state = {
            filter: -1,
            order: "Liga",
            items: null,
            errors: [],
            visibleColumns: ['_id', 'title', 'productId', 'price'],
            availableColumns: [
                { key: '_id', label: 'Id' },
                { key: 'productId', label: 'ProductId' },
                { key: 'title', label: 'Title' },
                { key: 'price', label: 'Price' },
                { key: 'description', label: 'Description' }
            ],
        };
        this.init = this.init.bind(this);
        this.remove = this.remove.bind(this);
        this.save = this.save.bind(this);
        this.exportObjs = this.exportObjs.bind(this);
        this.importObjs = this.importObjs.bind(this);
        this.importCsv = this.importCsv.bind(this);
        this.loadColumnSettings = this.loadColumnSettings.bind(this);
        this.saveColumnSettings = this.saveColumnSettings.bind(this);
        this.toggleColumn = this.toggleColumn.bind(this);
    }

    componentDidMount() {
        this.loadColumnSettings();
        this.init();
    }

    async init() {
        console.log("Initializing...");
        let responseProducts = await fetcher(`${config.API()}collection/products`);
        let products = await responseProducts.json();
        this.setState({ items: products });
    }

    async save(values) {
        try {
            const body = JSON.stringify(values);
            await fetcher(`${config.API()}collection/products/save`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body,
            });
            return true;
        } catch (err) {
            this.setState(prevState => ({
                errors: [...prevState.errors, `Failed to save product ${values.productId}: ${err.message}`]
            }));
            return false;
        }
    }

    remove = (eventId) => {
        return (e) => {
            let isOk = window.confirm("Are you sure?");
            if (!isOk) return;
            fetcher(`${config.API()}collection/products/remove/${eventId}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: "{}"
            })
                .then(response => response.json())
                .then(data => {
                    let items = this.state.items;
                    _.remove(items, x => x._id === eventId);
                    this.setState({ items });
                });
        };
    };

    linkToEdit = (eventId) => {
        return () => {
            this.setState({ redirect: `/products/${eventId}` });
        };
    };

    exportObjs = () => downloadFile(JSON.stringify(this.state.items, null, "\t"), "products.json", 'text/plain');

    importObjs = async (e) => {
        let text = await readFileAsync(e);
        let objs = JSON.parse(text);
        await fetcher(`${config.API()}collection/products/import`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: text
        });
        this.init();
    };


    async importCsv(e) {
        const file = e.target.files[0];
        Papa.parse(file, {
            complete: async (result) => {
                const importedProducts = result.data.slice(1).map(row => {
                    const productId = row[0];
                    const existingProduct = this.state.items?.find(item => item.productId === productId);
                    const localeData = row[4]?.split(';').map(s => s.trim()) || ['', '', ''];
                    const priceData = row[6]?.split(';').map(s => s.trim()) || [];
                    const usPriceIndex = priceData.indexOf('US');
                    const price = usPriceIndex !== -1 && priceData[usPriceIndex + 1]
                        ? parseFloat(priceData[usPriceIndex + 1]) / 1000000
                        : 0;
                    return {
                        _id: existingProduct ? existingProduct._id : 'new',
                        productId,
                        title: localeData[1] || '',
                        price,
                        description: localeData[2] || '',
                    };
                }).filter(product => product.productId);

                this.setState({ errors: [] });
                for (const product of importedProducts) {
                    await this.save(product);
                }
                this.init();
            },
            header: false,
        });
    }

    loadColumnSettings() {
        const savedColumns = localStorage.getItem('productsTableColumns');
        if (savedColumns) {
            let visibleColumns = JSON.parse(savedColumns);

            this.setState({ visibleColumns });
        }
    }

    saveColumnSettings() {
        localStorage.setItem('productsTableColumns', JSON.stringify(this.state.visibleColumns));
    }

    toggleColumn(columnKey) {
        this.setState(prevState => {
            const visibleColumns = prevState.visibleColumns.includes(columnKey)
                ? prevState.visibleColumns.filter(col => col !== columnKey)
                : [...prevState.visibleColumns, columnKey];
            return { visibleColumns };
        }, this.saveColumnSettings);
    }

    render() {
        if (this.state.redirect) {
            return <Redirect push to={this.state.redirect} />;
        }

        if (!this.state.items) {
            return <div>Loading</div>;
        }

        return (
            <div>
                <div className="card shadow w-100">
                    <div className="card-header py-3">
                        <h2 className="m-0 font-weight-bold l">Products</h2>
                        <input
                            onChange={this.importCsv}
                            type="file"
                            accept=".csv"
                            id="file-input-csv"
                            title=".csv file from google store"
                            className="l btn btn-icon btn-light ml-1"
                        />
                        <input
                            onChange={this.importObjs}
                            type="file"
                            accept=".json"
                            id="file-input-json"
                            className="r btn btn-icon btn-light ml-1"
                        />
                        <button onClick={this.exportObjs} className="r btn btn-icon btn-light ml-1">
                            <i className="fas fa-fw fa-arrow-circle-down"></i> Export JSON
                        </button>
                    </div>
                    <div className="card-body">
                        {this.state.errors.length > 0 && (
                            <div className="alert alert-danger">
                                {this.state.errors.map((error, index) => (
                                    <div key={index}>{error}</div>
                                ))}
                            </div>
                        )}
                        <div className="row mb-3">
                            <div className="col-12">
                                <div className="d-flex flex-wrap">
                                    {this.state.availableColumns.map(col => (
                                        <div key={"ac"+col.key} className="form-check mr-3 small">
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id={`column-${col.key}`}
                                                checked={this.state.visibleColumns.includes(col.key)}
                                                onChange={() => this.toggleColumn(col.key)}
                                            />
                                            <label className="form-check-label" htmlFor={`column-${col.key}`}>
                                                {col.label}
                                            </label>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        </div>
                        <div className="product-responsive">
                            <table className="dataTable table table-align-middle table-bordered table-sm" width="100%" cellSpacing="0">
                                <thead>
                                <tr>
                                    {this.state.visibleColumns.map(col => (
                                        <th key={"vc"+col}>{this.state.availableColumns.find(c => c.key === col).label}</th>
                                    ))}
                                    <th></th>
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.items.map((x, i) => (
                                    <tr key={`h${x._id}`}>
                                        {this.state.visibleColumns.map(col => (
                                            <td key={`${x._id}-${col}`}>
                                                {col === 'countries' ? x[col]?.join(',') || 'all' : x[col]}
                                            </td>
                                        ))}
                                        <td>
                                            <button
                                                className="btn btn-outline-danger btn-circle btn-sm"
                                                onClick={this.remove(x._id)}
                                            >
                                                <i className="fa fa-remove"></i>
                                            </button>
                                            <button
                                                className="btn btn-outline-primary btn-circle btn-sm"
                                                onClick={this.linkToEdit(x._id)}
                                            >
                                                <i className="fa fa-edit"></i>
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                        <div className="r">
                            <button onClick={this.linkToEdit("new")} className="btn btn-icon btn-primary ml-1">
                                <i className="fas fa-fw fa-plus-square"></i> Add
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}